import { AclosetError } from './AclosetError';

/**
 * 사용자에게 보여줄 메시지를 가지는 에러.
 */
export class AclosetMessageError extends AclosetError {
  readonly text?: string;
  readonly code?: string;

  constructor(error: any, text?: string, code?: string) {
    super(error);
    this.text = text;
    this.code = code;
  }

  override toString() {
    return this.text != null ? `${this.code ? `[${this.code}]` : ''}${this.text} (${this.message})` : this.message;
  }

  override get userMessage() {
    return this.text ?? this.message;
  }
}
